// extracted by mini-css-extract-plugin
export var labelWrapper = "_m8-0";